import { ActionType } from '../action-types/index'
import { TrainingActions } from '../actions/index'
import { TrainingState } from "../../models"

const initialTrainingState: TrainingState = {}

const trainingStateReducer = (state: TrainingState = initialTrainingState, action: TrainingActions) => {
    switch (action.type) {
        case ActionType.UpdateTrainingState:
            return state = action.payload
        case ActionType.ClearTrainingState:
            return state = {}
        default:
            return state
    }
}

export default trainingStateReducer